var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{on:{"click":function($event){return _vm.download()}}},[_c('font-awesome-icon',{attrs:{"icon":"download"}}),_c('span',[_vm._v("Download .zip of all assets")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }